import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import CommonTemplate from "templates/common-template"
import CareerList from "components/lists/careers-list"

// markup
const IndexPage = ({ location }) => {
    const data = useStaticQuery(query)
    const { posts, pageData } = data

    const { category } = pageData

    const breadcrums = [category.subtitle || category.name]

    const customJsx = <CareerList data={posts} url={location.pathname} />

    const arrData = {
        location,
        data,
        bgColor:
            "linear-gradient(90deg, #f9e07f 25%, #f9e38e 25%, #f9e38e 50%, #f9e07f 50%, #f9e07f 75%, #f9e38e 75%, #f9e38e 100%)",
        // galleryMinWidth: "40%", //default 0
        customElement: customJsx,
        breadcrums, // allow null
    }

    return <CommonTemplate {...arrData} />
}

export default IndexPage

const query = graphql`
    {
        pageData: strapiPage(
            slug: { eq: "eip-careers" }
            company: { shortname: { eq: "EIP" } }
        ) {
            title
            menu_title
            description
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            category {
                name
                subtitle
                category_img {
                    childImageSharp {
                        gatsbyImageData(placeholder: BLURRED)
                    }
                }
            }
            content {
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
                Multi_Columns {
                    Text_Alignment
                    content
                    id
                    title
                }
                Text_With_Image {
                    Image_Size
                    Layout_Type
                    content
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                            original {
                                width
                            }
                        }
                    }
                }
                Gallery_Image {
                    title
                    media {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                backgroundColor: "#f2f2f2"
                            )
                        }
                        publicURL
                    }
                }
                Accordion {
                    content
                    title
                }
                external_script {
                    name
                    script
                }
            }
        }
        posts: allStrapiJob {
            edges {
                node {
                    title
                    slug
                    employment_type
                }
            }
        }
    }
`
